export default {
  data: {
    auth: null,
  },
  list: [],
  userData: {},
  redirect: "",
};
